import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import * as actions from '@appStore/products/actions';
import { ActionTypes, AgreementLinkLoad } from '@appStore/products/actions';
import { AgreementService } from '@appStore/products/services/agreement.service';

@Injectable()
export class AgreementEffects{
    constructor(private agreementService: AgreementService, private actions$: Actions){}

    createProductAgreement$ = createEffect(() =>{
        return this.actions$.pipe(
          ofType(ActionTypes.CreateProductAgreement),
          exhaustMap((action: actions.CreateProductAgreement) => {
            return this.agreementService.createProductAgreement(action.payload).pipe(
              map(item => new actions.CreateProductAgreementSuccess(item)),
              catchError(error => of(new actions.CreateProductAgreementFail(error)))
            );
          })
        );
    });

    getAgreementLink$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ActionTypes.AgreementLinkLoad),
            exhaustMap((action: AgreementLinkLoad) => {
                return this.agreementService.getAgreementLink(action.agreementId).pipe(
                    map(link => new actions.AgreementLinkLoadSuccess(link)),
                    catchError(error => of(new actions.AgreementLinkLoadFail(error)))
                );
            })
        );
    });
}